"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "TEXT";
    MessageType["STATUS"] = "STATUS";
    MessageType["IMAGE"] = "IMAGE";
    MessageType["AUDIO"] = "AUDIO";
    MessageType["VIDEO"] = "VIDEO";
    MessageType["DOCUMENT"] = "DOCUMENT";
    MessageType["NOTSET"] = "NOTSET";
    MessageType["LOCATION"] = "LOCATION";
    MessageType["CONTACT"] = "CONTACT";
    MessageType["TASK_CREATED"] = "TASK_CREATED";
    MessageType["TASK_CHANGED"] = "TASK_CHANGED";
    MessageType["TASK_COMPLETED"] = "TASK_COMPLETED";
    MessageType["TASK_ASSIGNEE_CHANGED"] = "TASK_ASSIGNEE_CHANGED";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
//# sourceMappingURL=MessageType.js.map